import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { TableRow, TableBody, TableCell, Typography } from '@mui/material';

import Loader from 'src/components/loaders/Loader';
import EmptyTable from 'src/components/tables/emptyTable';

import TagRow from './tagRow';

function TagsTableBody({
  isLoading,
  isNotFound,
  searchIsNotFound,
  filteredTags,
  page,
  rowsPerPage,
  isSelected,
  setSelectedTags,
  handleOpenMenu,
  handleOpenUpdateModal,
  filterName,
  canUpdate,
  canDelete,
  showCheckBox,
  showOptions,
  showDeptAndCreator,
}) {
  const handleClick = (event, id) => {
    setSelectedTags((prevSelected) => {
      const selectedIndex = prevSelected.indexOf(id);

      if (selectedIndex === -1) {
        return [...prevSelected, id];
      }

      return prevSelected.filter((item) => item !== id);
    });
  };
  const { t } = useTranslation();

  return (
    <>
      {isLoading ? (
        <TableBody>
          <TableRow>
            <TableCell colSpan={13} sx={{ textAlign: 'center' }}>
              <Loader size={150} />
            </TableCell>
          </TableRow>
        </TableBody>
      ) : (
        <>
          {filteredTags.length === 0 ? (
            <TableBody>
              <TableRow>
                <TableCell colSpan={12} align="center" sx={{ py: 4 }}>
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'text.disabled',
                      fontStyle: 'italic',
                      fontWeight: 600,
                    }}
                  >
                    {t('tables.noData')}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          ) : isNotFound ? (
            <EmptyTable
              filterName={filterName}
              colSpan={12}
              searchIsNotFound={searchIsNotFound}
            />
          ) : (
            <TableBody>
              {filteredTags
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((tag, idx) => {
                  const isItemSelected = isSelected(tag.id);
                  return (
                    <TagRow
                      key={idx}
                      tag={tag}
                      isItemSelected={isItemSelected}
                      handleClick={handleClick}
                      handleOpenMenu={handleOpenMenu}
                      onRowClick={handleOpenUpdateModal}
                      showCheckBox={showCheckBox}
                      showOptions={showOptions}
                      showDeptAndCreator={showDeptAndCreator}
                      canUpdate={canUpdate}
                      canDelete={canDelete}
                    />
                  );
                })}
            </TableBody>
          )}
        </>
      )}
    </>
  );
}

TagsTableBody.propTypes = {
  isLoading: PropTypes.bool,
  isNotFound: PropTypes.bool,
  searchIsNotFound: PropTypes.bool,
  filteredTags: PropTypes.array,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  isSelected: PropTypes.func,
  setSelectedTags: PropTypes.func,
  handleOpenMenu: PropTypes.func,
  handleOpenUpdateModal: PropTypes.func,
  filterName: PropTypes.string,
  canUpdate: PropTypes.bool,
  canDelete: PropTypes.bool,
  showCheckBox: PropTypes.bool,
  showOptions: PropTypes.bool,
  showDeptAndCreator: PropTypes.bool,
};

export default TagsTableBody;
